import React from "react";
import { Row, Col } from "react-bootstrap";
import { PoolTokenType } from "impermax-sdk";
import usePoolToken from "../../../hooks/usePoolToken";
import { formatFloat } from "../../../utils/format";
import useGenericCall from "../../../hooks/useGenericCall";
import { useOnchainLendingPool } from "../../../hooks/useOnchain";


export interface TransactionSizeProps {
  amount: number;
}

export default function TransactionSize({amount}: TransactionSizeProps) {
  const poolTokenType = usePoolToken();
  if (poolTokenType != PoolTokenType.Collateral) return null;

  const data = useGenericCall(useOnchainLendingPool(), async onchainLendingPool => ({
    reserveWeights: await onchainLendingPool.getMarketReservesWeights(),
    tokenPrices: await onchainLendingPool.getPriceDenomLP(),
    symbolA: await (await onchainLendingPool.getBorrowableA().getOffchainBorrowable()).getSymbol(),
    symbolB: await (await onchainLendingPool.getBorrowableB().getOffchainBorrowable()).getSymbol(),
  }));

  if (!data) return (null);

  return (
    <Row>
      <Col xs={6}>Transaction size:</Col>
      <Col xs={6} className="text-right">
        {formatFloat(amount * data.reserveWeights[0] / data.tokenPrices[0])} {data.symbolA}
        <br/> + 
        {formatFloat(amount * data.reserveWeights[1] / data.tokenPrices[1])} {data.symbolB}
      </Col>
    </Row>
  );
}